import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderTernopil(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-ternopil/create-distribution-order-ternopil",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderTernopil(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-ternopil/create-distribution-to-order-ternopil",
      params,
      callBackFn
    );
  },
  async getTernopilAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-ternopil/get-ternopil-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
